import { DataModel } from "common/models/utility-models/base-model";

export class ForgotPasswordModel extends DataModel {
    email : any = ""
}